<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0">
      <v-icon class="page-icon" color="#2e384d" size=60>mdi-car-arrow-left</v-icon>
      <p class="desc">{{ $t('selectRegMethod.description') }}</p>
      <form action="#" @submit.prevent="submit">
        <v-radio-group v-model="choice" class="option-group">
          <v-radio
            v-for="(option, index) in regOptions"
            :key="index"
            :value="index"
            color="#2e5bff"
          >
            <template v-slot:label>
              <span class="option-label">{{ option }}</span>
            </template>
          </v-radio>
        </v-radio-group>
        <v-btn
          class="submit-btn"
          type="submit"
          height="45px"
          color="#033e8c"
          depressed
          block
          dark
          >
          {{ title }}
        </v-btn>
      </form>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"

export default {
  name: "SelectRegistrationMethodPage",
  props: {},
  components: {
    AppBar,
  },
  data() {
    return {
      title: '',
      valid: false,
      choice: 0
    }
  },
  computed: {
    regOptions: function () {
      return [this.$t('selectRegMethod.usingVIN'), this.$t('selectRegMethod.usingRegistrationNumber')]
    }
  },
  methods: {
    submit() {
      const variables = {
        "variables": {
          "car_registration_method": {
            "value": this.choice == 0 ? 'vin' : 'license_plate_number'
          }
        }
      }

      const taskId = this.$store.getters.getCurrentTask?.id

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId, variables })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
      }
    }
  },
  created() {
    this.title = this.$store.getters.getCurrentTask.taskName
  }
}
</script>

<style scoped>
.option-group {
  padding: 0 1.375rem;
}

.option-label {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #2e384d;
  margin-left: 0.8125rem;
}

.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
  margin-bottom: 1.375rem;
}
</style>